<template>
  <nav class="flex flex-row flex-nowrap" aria-label="Pagination">
    <a class="flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300"
       @click="fist()" v-if="value>1"
       href="#" title="Next Page">
      <span class="sr-only">Next Page</span>
      <svg class="block h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
      </svg>
      <svg class="block h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
      </svg>
    </a>
    <a class="flex w-10 h-10 mr-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300"
       @click="previous"
       v-if="value>1"
       href="#" title="Previous Page">
      <span class="sr-only">Previous Page</span>
      <svg class="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path>
      </svg>
    </a>
    <a class="hidden xs:flex sm:flex  md:flex w-10 h-10 mx-1 justify-center items-center rounded-full border "
       @click="go(n)"
       href="#" title="Page 1" v-for="n in arrayGenerate"
       :class="n===value?'border-primary bg-primary text-white pointer-events-none':'border-gray-200 bg-white text-black hover:border-gray-300'">
      {{ n }}
    </a>
    <a class="flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300"
       @click="next()" v-if="value<last_page"
       href="#" title="Next Page">
      <span class="sr-only">Next Page</span>
      <svg class="block w-4 h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path>
      </svg>
    </a>
    <a class="flex w-10 h-10 ml-1 justify-center items-center rounded-full border border-gray-200 bg-white text-black hover:border-gray-300"
       @click="last()" v-if="value<last_page"
       href="#" title="Next Page">
      <span class="sr-only">Next Page</span>
      <svg class="block h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path>
      </svg>
      <svg class="block h-4 fill-current" viewBox="0 0 256 512" aria-hidden="true" role="presentation">
        <path
            d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path>
      </svg>
    </a>
  </nav>
</template>

<script>
export default {
  name: "paginacion",
  props: {
    totalRows: {
      type: Number,
      default: 0
    },
    perPage: {
      //type: Number,
      default: 5,
    },
    value: {
      default: 1
    },
  },
  data: () => ({
    items: null,
    last_page: null,
    fist_page: null,
    n: 3
  }),
  mounted() {
    this.calculate()
  },
  watch: {
    totalRows() {
      this.calculate()
    },
    perPage() {
      this.calculate()
    }
  },
  methods: {
    fist() {
      this.$emit('input', 1)
      this.$emit('change', 1)
    },
    next() {
      let auxiliar = this.value
      ++auxiliar
      this.$emit('input', auxiliar)
      this.$emit('change', auxiliar)
    },
    previous() {
      let auxiliar = this.value
      --auxiliar
      this.$emit('input', auxiliar)
      this.$emit('change', auxiliar)
    },
    go(index) {
      this.$emit('input', index)
      this.$emit('change', index)
    },
    last() {
      this.$emit('input', this.last_page)
      this.$emit('change', this.last_page)
    },
    calculate() {
      //this.last_page = Math.ceil(this.totalRows / this.perPage)
       this.last_page = Math.ceil(this.totalRows /
           (isNaN(this.perPage) ? Number(this.perPage) : this.perPage) )
    },
  },
  computed: {
    arrayGenerate() {
      let aux = []
      let length = screen.width >= 500 ? 5 : 2
      if (this.last_page > length && this.value > 2) {
        if (this.value + 2 <= this.last_page){
          let temp=length===2 ? 1 : 2
          for (let i = this.value - temp; i <= this.value + temp; i++) aux.push(i)
        }
        else{
          let temp=length===2 ? 1 : 4
          for (let i = this.value - temp; i <= this.last_page; i++) aux.push(i)
        }
      } else if (this.last_page > length && this.value <= 2) {
        for (let i = 1; i <= length+1; i++) aux.push(i)
      } else
        for (let i = 1; i <= this.last_page; i++) aux.push(i)
      return aux
    }
  },
}
</script>

<style scoped>

</style>